import styled, { css } from 'styled-components';

import ArrowLink from 'Elements/Link/Arrow';
import Icon from 'Elements/Icon';

export const Container = styled.section`
    ${({ theme }) => css`
        background: var(--infoBar-bg-colour, ${theme.colors.tertiary.hex});
        color: var(--infoBar-txt-colour, ${theme.colors.accents[3].hex});
        padding: 1rem 0;
    `}
`;

export const Heading = styled.h2<{ $withIcon: boolean }>`
    ${({ theme, $withIcon }) => css`
        margin: 0;
        font-family: ${theme.fonts.secondary};
        font-weight: 300;
        font-size: 1.5rem;
        line-height: 1.25;

        @media ${theme.breakpoints.large.media} {
            font-size: 2rem;
            max-width: 25rem;
        }

        ${$withIcon &&
        css`
            margin: 0 auto;
            max-width: none;
        `}
    `}
`;

export const StyledIcon = styled(Icon)`
    ${({ theme }) => css`
        color: var(--infoBar-txt-colour, ${theme.colors.accents[3].hex});
        height: 2.5rem;
        width: 2.5rem;
        padding-right: 1rem;
        vertical-align: middle;

        @media ${theme.breakpoints.large.media} {
            height: 3.5rem;
            width: 3.5rem;
        }
    `}
`;

export const Description = styled.div`
    ${({ theme }) => css`
        margin-top: 0.5rem;

        @media ${theme.breakpoints.large.media} {
            margin-top: 0;
        }
    `}
`;

export const DescriptionLink = styled(ArrowLink)`
    margin-top: 0.5rem;
`;

export const Text = styled.div`
    ${({ theme }) => css`
        margin: 0.25rem 0;
        color: ${theme.colors.primaryContrast.hex};

        @media ${theme.breakpoints.large.media} {
            margin: 1rem 0;
            max-width: 32rem;
        }

        a {
            color: inherit;
        }
    `}
`;
